/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiGet, apiPost } from './common/api';
import endpoints from 'src/shared/service/endpoint/endpoints.class';
import { manageApiError } from './common/api.lib';
import { IApiResponse } from '@shared/interface/api-response.interface';
import { ICsrf } from '@shared/interface/security.interface';
import { ApiError } from '@shared/error/api.error';
import { logger } from '@shared/lib/logger/logger-manager';

// Get CSRF for a given formname
interface IApiGetCsrf {
  formName?: string
  fingerprint?: string
}
export const apiGetCsrf = (params: IApiGetCsrf): Promise<any> => {
  const endpointClass = endpoints.security.getCsrf;
  return apiGet(
    endpointClass.addParams([params.formName, params.fingerprint]).getUrl(),
    {
      publicApi: endpointClass.isPublic(),
    }
  )
    .then((response?: IApiResponse<Array<ICsrf>>) => {
      if (response != null && response.returnCode === 'CSRF_GET_OK') {
        return Promise.resolve(response.returnSuccess);
      } else {
        throw new ApiError(response?.returnError ?? '', response?.returnCode);
      }
    })
    .catch((error: ErrorConstructor) =>
      manageApiError(error, 'apiGetChangelog'),
    );
};

// Post and get all CSRF
interface IApiPostAllCsrf {
  fingerprint?: string
  formNameList?: Array<string>
}
export const apiPostAllCsrf = (params: IApiPostAllCsrf): Promise<any> => {
  const endpointClass = endpoints.security.getCsrf;
  return apiPost(endpointClass.getUrl(),
  {
    fingerprint: params.fingerprint,
    formNameList: params.formNameList
  },
  {
    publicApi: endpointClass.isPublic(),
  })
    .then((response?: IApiResponse<Array<ICsrf>>) => {
      if (response != null && response.returnCode === 'CSRF_GET_OK') {
        return Promise.resolve(response.returnSuccess);
      } else {
        throw new ApiError(response?.returnError ?? '', response?.returnCode);
      }
    })
    .catch((error: ErrorConstructor) => {
      manageApiError(error, 'apiPostAllCsrf')
    });
};
